var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF2C3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1001 29.9248 3.5063-2.6294 2.5366 2.5366c.3906.3906 1.0234.3906 1.4141 0l2.4429-2.4428 2.4429 2.4429c.3906.3906 1.0234.3906 1.4141 0l2.5366-2.5366 3.5063 2.6294c.1768.1323.3877.2002.6001.2002.1523 0 .3057-.0347.4473-.1055.3388-.1695.5527-.5157.5527-.8946v-26.25c0-.5522-.4478-1-1-1h-21c-.5522 0-1 .4478-1 1v26.25c0 .3789.2139.7251.5527.8945.3374.169.7427.1324 1.0474-.0947zm.3999-26.0498h19v23.25l-2.6001-1.9497c-.3994-.2993-.9561-.2593-1.3071.0928l-2.4429 2.4429-2.4429-2.4429c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-2.4429 2.4429-2.4429-2.4429c-.3516-.3521-.9087-.3921-1.3071-.0928l-2.6001 1.9497z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.75 20.6748h10.5c.5522 0 1-.4478 1-1s-.4478-1-1-1h-10.5c-.5522 0-1 .4478-1 1s.4478 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.75 15.4248h10.5c.5522 0 1-.4478 1-1s-.4478-1-1-1h-10.5c-.5522 0-1 .4478-1 1s.4478 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.75 10.1748h10.5c.5522 0 1-.4478 1-1s-.4478-1-1-1h-10.5c-.5522 0-1 .4478-1 1s.4478 1 1 1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.d1e9d7e7542db018f242f484284d35f4.svg";
export { ForwardRef as ReactComponent };